module.exports = __webpack_public_path__ + "static/media/document.03561a77.svg";